<template>
    <div class="jobDetail coursesDetail  Regular" :class="{'coursesDetailPC':$store.state.innerWidth>768}">
        
        <div class="assistant"  >
            <Breadcrumbs></Breadcrumbs>
            <div class="a-content pad-15 row courses-content" >
                <div class="coursesPC">
                   <h2 class="col-sm-10 Bold coursesTitle padLeft-0">{{$store.getters.getObject(course.langMap).title}}</h2>
                   <div class="courseTip col-sm-10"  v-if="$store.getters.getObject(course.langMap).description" v-html="$store.getters.getObject(course.langMap).description">
                   </div>
                   <div class="col-sm-6 coursesQR padLeft-0">
                       <div class="item-table pad-5" >
                            <div class="tdcell">
                                <p v-if="course.qrNo" style="padding-bottom:15px">{{$t('message.QR number:')}} {{course.qrNo}}</p>
                                <p v-if="course.isCef && course.cefNo.length==0" class=" itemContent1">
                                    <span>{{$t('message.CEF')}}</span>
                                    <i class="icon-i pad-l-10 pointer" v-on:click="getCEFInfo()"></i>
                                </p>
                                <p class="itemContent1">
                                    <span>{{$t('message.QR Courses')}}</span>
                                    <i class="icon-i pad-l-10 pointer" v-on:click="getQRInfo()"></i> 
                                </p>
                            </div>
                       </div>
                   </div>
                </div>
            </div>
            <div class="imgGroup" v-if="$store.state.innerWidth>768">
                <img class="img1 noSelect" src="../images/deco-21.png" />
                <img class="img2 noSelect" src="../images/deco-17.png" />
                <img class="img3 noSelect" src="../images/deco-10.png" />
                <img class="img4 noSelect" src="../images/deco-18.png" />
            </div>
        </div>
        <div class="description courses-content" >
            <div class="coursesPC pad-15"  >
                <div class="col-sm-6 pad-r-40 pad-t-100 course-item"  v-if="$store.getters.getObject(course.langMap).grantingBody">
                    <div class="item-table" ref='item1'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Course Provider')}}</h3>
                             <p class="circle itemContent" v-for="(grantingBody,index) in $store.getters.getObject(course.langMap).grantingBody">{{grantingBody}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/school.png" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pad-l-40 pad-t-100 course-item"  v-if="$store.getters.getObject(course.langMap).areaOfStudy">
                    <div class="item-table" ref='item2'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Area of Study')}}</h3>
                            <p class="circle itemContent" v-for="(areaOfStudy,index) in $store.getters.getObject(course.langMap).areaOfStudy">{{areaOfStudy}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/area of study.png" />
                        </div>
                    </div>
                </div>
                <!-- <div class="col-sm-6 pad-l-40 pad-t-100 course-item"  v-if="course.areaOfStudyKey">
                    <div class="item-table" ref='item2'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Area of Study')}}</h3>
                            <p class="circle itemContent">{{course.areaOfStudyKey}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/area of study.png" />
                        </div>
                    </div>
                </div> -->
                <div class="col-sm-6 pad-r-40 pad-t-100 course-item"   v-if="course.dataSource=='qr'&&course.learningMode">
                    <div class="item-table" ref='item3'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Learning mode')}}</h3>
                            <p class="circle itemContent" 
                            v-for="mode in course.learningMode" 
                            v-if="$store.getters.getTrim(mode)=='FT'||$store.getters.getTrim(mode)=='PT'||$store.getters.getTrim(mode)=='DL'||$store.getters.getTrim(mode)=='EL'||$store.getters.getTrim(mode)=='Not Applicable'" 
                            >
                                {{$t('message.'+ $store.getters.getTrim(mode) +'')}}
                            </p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/learnig mode.png" />
                        </div>
                    </div>
                </div>

                <div class="col-sm-6 pad-l-40 pad-t-100 course-item" v-if="course.level&&course.subDataSource != 'Microsoft'&&course.isQr">
                    <div class="item-table" ref='item4'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Level')}}</h3>
                            <p class="circle itemContent"><span v-if="course.dataSource=='qr'">{{$t('message.QF level')}}</span>{{course.level}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/Level.png" />
                        </div>
                    </div>
                </div>
                <div class="col-sm-6 pad-l-40 pad-t-100 course-item"   v-if="course.microsoftLevel&&course.subDataSource == 'Microsoft'">
                    <div class="item-table" ref='item5'>
                        <div class="tdcell">
                            <h3 class="Bold desc-title">{{$t('message.Level')}}</h3>
                            <p class="circle itemContent" v-for="(areaOfStudy,index) in course.microsoftLevel">{{titleCase(areaOfStudy)}}</p>
                        </div>
                        <div class="tdcell icon">
                            <img class="noSelect" src="../images/Level.png" />
                        </div>
                    </div>
                </div>

            </div>
            <div class=" coursesPC pad-15" v-if="$store.getters.getObject(course.langMap).requirements">
                <div class="col-sm-12 pad-t-100 padLeft-0 padRight-0"  v-if="course.dataSource=='qr'">
                   <h3 class="Bold desc-title learnTitle">{{$t('message.course requirements')}}</h3>
                   <p class="circle itemContent" style="white-space: pre-line" v-html="$store.getters.getObject(course.langMap).requirements"></p>
                </div>
            </div>
        </div>
        <div class="courses-content " >
            <div class="coursesPC shareContent">
                <div style="text-align: left" class="center pad-tb-50 learnMore" v-if="course.marketingUrl">
                    <div class="btn btn-primary op-rc-Btn" v-on:click="learnMore(course.marketingUrl[0])" role="button" :aria-label="$t('message.Go to course page')">
                       <a href="javascript:;" style="color: inherit">{{$t('message.Go to course page')}}</a>
                    </div>
                </div>
				<div class="cefBox" :class="{'col-sm-11': $store.state.innerWidth>980}" v-if="course.cefList.length!=0">
					<div class="Bold listTitle">{{ $t("message.CEF course") }}</div>
					<div class="cefList">
						<div class="cefCourse" v-for="(cef, index) in course.cefList" :key="index">
							<div class="courseTitle">{{$store.getters.getObject(cef.langMap).title}}</div>
							<div class="courseProvider">
								<p v-for="(grantingBody,index) in $store.getters.getObject(cef.langMap).grantingBody" :key="index">{{grantingBody}}</p>
							</div>
							<div class="tag">
								<span
									class="timeTip SemiBold"
									v-if="$store.getters.getTrim(mode)=='FT'||$store.getters.getTrim(mode)=='PT'||$store.getters.getTrim(mode)=='DL'||$store.getters.getTrim(mode)=='EL'"
									v-for="(mode, mIndex) in course.learningMode"
									:key="mIndex"
								>
									{{$t('message.'+$store.getters.getTrim(mode)+'')}}
								</span>
								<!-- <span class="timeTip SemiBold">CEF</span> -->
							</div>
							<div class="courseIcon" @click="goCourseDetail(cef)">
								<svg t="1642069194556" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="24687" width="32" height="32">
									<path d="M512 64c-247.039484 0-448 200.960516-448 448S264.960516 960 512 960 960 759.039484 960 512 759.039484 64 512 64zM661.760516 535.967531l-160.25545 158.495686c-6.239161 6.14455-14.368821 9.247789-22.496761 9.247789-8.255235 0-16.512189-3.168606-22.751351-9.504099-12.416396-12.576374-12.320065-32.800753 0.25631-45.248112l137.407768-135.904314-136.287918-136.671523c-12.480043-12.512727-12.447359-32.768069 0.063647-45.248112 12.512727-12.512727 32.768069-12.447359 45.248112 0.063647l158.911974 159.359226c0.032684 0.032684 0.032684 0.063647 0.063647 0.096331s0.063647 0.032684 0.096331 0.063647c2.94326 2.975944 5.055665 6.431824 6.591802 10.047682 0.063647 0.127295 0.223626 0.25631 0.25631 0.383604C673.600645 512.767209 671.231931 526.592447 661.760516 535.967531z" p-id="24688" fill="#22225D"></path>
								</svg>
							</div>
						</div>
					</div>
				</div>
                
                <div v-if="course.cefList.length!=0" style="text-align: left" class="col-sm-12 center pad-tb-50 learnMore">
                    <div class="btn btn-primary op-rc-Btn" v-on:click="viewAllCourse" role="button" :aria-label="$t('message.View all QR Courses')">
                       <a href="javascript:;" style="color: inherit">{{$t('message.Course View all')}}</a>
                    </div>
                </div>
                <!-- <div class="col-sm-12 References" @click="toKnowMore"><span>{{$t('message.To know more')}}</span><i class="icon-arrow-right"></i></div> -->
            
            </div>
			<div class="coursesPC shareContent">
				<ShareBar v-if="showShareBar"></ShareBar>
			</div>
        </div>

		<!-- Related Courses -->
        <div v-if="courses.qrCourse.length>0||courses.edxCourse.length>0">
            <div class="courses-content">
                <div class="coursesPC">
                    <div class="mainColor box-img-bg"  :class="{'padding-30':swiperPedding}">
                        <h2 class="relatedCourses">{{$t('message.RelatedCourses')}} 
                        <img class="noSelect" src="../images/deco1.png" /></h2>
                    </div>
                    <SwiperQRcourses :course-list="courses.qrCourse" v-if="select==1&&courses.qrCourse.length>0"></SwiperQRcourses>
                    <SwiperMOOCcourses :course-list="courses.edxCourse" v-if="select==2&&courses.edxCourse.length>0"></SwiperMOOCcourses>
                    <div class="center pad-tb-50">
                        <div class="btn btn-primary op-rc-Btn" role="button" :aria-label="$t('message.View all qualifications')" v-if="select==1&&courses.qrCourse.length>5||select==2&&courses.edxCourse.length>5" @click="viewAllEvent()">
                           <a href="javascript:;" style="color: inherit">{{$t('message.View all qualifications')}}</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- related Occupation -->
        <div style="background-color: rgba(251, 183, 50, 0.03);">
            <div v-if="courseOccupationList.length > 0" class="relatedOccupation" :class="{'relatedOccupationMobile':$store.state.innerWidth<769}">
                <div class="mainColor" :class="{'padding-30':swiperPedding}" style="margin-bottom: 40px">
                    <h2 class="occupation-title">
                    {{ $t("message.RelatedOccupation") }}
                    <img
                        class="relatedOccupation-deco-22 noSelect"
                        src="../images/deco-22.png"
                    />
                    </h2>
                </div>
                <div class="courseRelateOccuSwiper" :style="$store.state.innerWidth > 814 &&  $store.state.innerWidth < 1345 ? 'padding: 0 34px 0 37px' : ''">
                    <SwiperOccupation ref="SwiperOccupation" :occupation-list="courseOccupationList"></SwiperOccupation>
                </div>
                <div class="center pad-tb-50">
                    <div
                        class="btn btn-primary op-rc-Btn btnJia SemiBold"
                        @click="viewAllOccupationEvent()"
                        role="button"
                        :aria-label="$t('message.View all')"
                    >
                        <a href="javascript:;" style="color: inherit">{{ $t("message.View all") }}</a>
                    </div>
                </div>
            </div>
        </div>

        <div class="occ-discover">
              <div class="courses-placeImg">
                <div class="occ-deco-12">
                  <img class="noSelect" src="../images/deco-12.png" />
                </div>
              </div>
            <div class="occ-discover-text SemiBold">
                <span>{{$t('message.Discover more career resources')}}</span>
            </div>
            <div class="center pad-tb-50 allBtn" @click="goRsources">
                <div class="btn btn-primary op-rc-Btn" role="button" :aria-label="$t('message.FInd out more')">
                    <a href="javascript:;" style="color: inherit">{{$t('message.FInd out more')}}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

    import SwiperQRcourses from '@/components/SwiperQRcourses.vue'
    import SwiperMOOCcourses from '@/components/SwiperMOOCcourses.vue'
    import Breadcrumbs from '@/components/Breadcrumbs'
    import ShareBar from '@/components/ShareBar.vue'
	import { EventBus } from "@/javascripts/eventBus.js";
	import SwiperOccupation from "@/components/SwiperOccupation.vue";

    export default {
        name:"coursesDetail",
    data() {
        return {
            select:1,
            course:{
                cefList: [],
            },
            courses:{
                qrCourse:[],
                edxCourse:[]
			},
			courseOccupationList: [],
            swiperPedding:false,
            showShareBar:false,
        }
    },   
    props: ["logGaEvent"],
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        }
    },
    computed:{
        innerwidth(){
          return this.$store.state.innerWidth;
        },
        _language(){
          return this.$store.state.language
        },
        key(){
            return this.$route.params.key;
        }
    },
    watch:{
        innerwidth (news,old) {
          this.checkWidth();
          this.setItemHeight();
        },
        _language:{
            handler: function(val, oldVal) {
                let that = this;
                if(this.$route.path.indexOf("coursesDetail")>0){
                    var breadcrumbs = this.$route.meta.breadcrumbs.find(
                        b => b.to.indexOf("coursesDetail")>0
                    );

                    // this.$router.push({query: {lang: val,name:this.$store.getters.replaceEvent(this.$store.getters.getObject(this.course.langMap).title)}})
                    let key = ""
                    if (this.course.dataSource == 'edx') {
                        key = this.course.key
                    } else {
                        key = this.course.id
                    }
                    key = encodeURIComponent(key)
                    if (breadcrumbs) {
                        breadcrumbs.text = this.$store.getters.getObject(this.course.langMap).title;
                        document.title = this.$store.state.mate.title =  this.$store.getters.getObject(that.course.langMap).title + this.$i18n.t("message.Courses_title");
                        this.$store.state.mate.description =  this.$i18n.t("message.Courses_desc");
                        this.$store.state.mate.keywords =  this.$i18n.t("message.Courses_keywords");
                        // if(this.$store.getters.getObject(this.course.langMap).description){
                        //     this.$store.state.mate.description = this.$store.getters.getObject(this.course.langMap).description;
                        // }
                        breadcrumbs.to = "/coursesDetail/"+ this.course.dataSource + "/" + key;
                    }
                }
                this.setItemHeight();
            },
            deep: true
        },
        key:{
            handler: function(val, oldVal) {
                if(this.key){
                    this.init();
                }
            },
            deep: true
        }
    },
    components: {
        SwiperQRcourses,
        Breadcrumbs,
        ShareBar,
		SwiperMOOCcourses,
		SwiperOccupation,
    },
    methods:{
        goRsources:function(){
            this.logGaEvent('userClick','courseDetail',"goResources")
            this.$router.push({ path: "/resources" , query:{lang:this.$store.state.language}});
            window.scrollTo(0, 0);
        },
        getCoursesList:function(key){
          let that = this;
          this.select = 1;
          that.api.getDetailLinkCourse({
              "key": key,
          }, function(data) {
              that.courses = data.result;
              for(let i=0;i<that.courses.qrCourse.length;i++){
                  if(that.courses.qrCourse[i].learningMode){
                      that.courses.qrCourse[i].learningMode = that.courses.qrCourse[i].learningMode.split(",")
                  }
              }
              for(let i=0;i<that.courses.edxCourse.length;i++){
                  if(that.courses.edxCourse[i].learningMode){
                      that.courses.edxCourse[i].learningMode = that.courses.edxCourse[i].learningMode.split(",")
                  }
              }
              if(that.courses.qrCourse.length==0&&that.courses.edxCourse.length>0){
                that.select = 2;
              }
          })
        },
        viewAllEvent:function(){
            this.$store.state.formData.courseKey = this.$route.params.key;
            if(this.select==1){
                this.$store.state.formData.coursesType = 3;
            }else if(this.select ==2){
                this.$store.state.formData.coursesType = 4;
            }
            this.logGaEvent('userClick','courseDetail',"ReratedCourses")
            this.$router.push({ path: '/ReratedCoursesT' , query:{lang:this.$store.state.language}});
        },
        checkWidth:function(){
          if(this.$store.state.innerWidth>=1345){
              this.swiperPedding = false;
          }else if(this.$store.state.innerWidth >= 1080){
              this.swiperPedding = true;
          }else if(this.$store.state.innerWidth >= 815){
              this.swiperPedding = true;
          }else{
              this.swiperPedding = false;
          }
        },
        setItemHeight:function(){
            var that = this;
            if(this.$store.state.innerWidth<768) return;
            setTimeout(function(){
                var height=0;
                for(var i=0;i<7;i++){
                    if(that.$refs['item'+(i+1)]){
                        that.$refs['item'+(i+1)].style.height = height+'px';
                    }
                    if(that.$refs['item'+(i+1)]&&that.$refs['item'+(i+1)].offsetHeight>height){
                        height = that.$refs['item'+(i+1)].offsetHeight
                    }
                    if(that.$refs['item'+(i+1)]){
                        that.$refs['item'+(i+1)].style.height = height+'px';
                    }
                }
            })
            
        },
        init:function(){
            let postData={}
            var that=this
            // localStorage.setItem('sign', 2);
            // if(this.$route.params.dataSource=="edx"){
            postData.key=decodeURIComponent(this.$route.params.key)
            // }else{
            //     postData.id=this.$route.params.key
            // }
            this.$store.state.selectMenu = 4;
            this.checkWidth();
            this.getCoursesList(decodeURIComponent(this.$route.params.key));
            this.getCourseOccupationList(decodeURIComponent(this.$route.params.key));
            this.showShareBar = false;
            this.api.getCourseDetail(postData, function(data) {
                that.course=data.result;
                if(that.course.subDataSource == 'Microsoft'){
                    that.course.durationInHour = Math.floor(that.course.durationInMinutes/60);
                    that.course.durationInMinutes = that.course.durationInMinutes%60;
                }
                if(that.course.learningMode){
                    that.course.learningMode = that.course.learningMode.split(",");
                }
                if(that.course.cefList.length != 0) {
                    for(let i=0;i<that.course.cefList.length;i++){
                        let learningMode = "";
                        if(that.course.cefList[i].learningMode){
                            learningMode = that.course.cefList[i].learningMode
                            that.course.cefList[i].learningMode = learningMode.split(",")
                        }
                    }
                }
                that.showShareBar = true;
                if(that.$route.path.indexOf("courseDetailQr")>0){
                    var breadcrumbs = that.$route.meta.breadcrumbs.find(
                        b => b.to.indexOf("courseDetailQr")>0
                    );

                    let key = ""
                    if (that.course.dataSource == 'edx') {
                        key = that.course.key
                    } else {
                        key = that.course.id
                    }
                    key = encodeURIComponent(key)
                    if (breadcrumbs) {
                        breadcrumbs.text = that.$store.getters.getObject(that.course.langMap).title
                        document.title = that.$store.state.mate.title =  that.$store.getters.getObject(that.course.langMap).title + that.$i18n.t("message.Courses_title");
                        that.$store.state.mate.description =  that.$i18n.t("message.Courses_desc");
                        that.$store.state.mate.keywords =  that.$i18n.t("message.Courses_keywords");
                        // if(that.$store.getters.getObject(that.course.langMap).description){
                        //     that.$store.state.mate.description = that.$store.getters.getObject(that.course.langMap).description;
                        // }
                        breadcrumbs.to = "/courseDetailQr/"+ that.course.dataSource + "/" + key;
                    }
                }
                that.setItemHeight();
            })
        },
        getCEFInfo:function(){
            var link = "<a  class='info-link mainColor ' href='"+this.$i18n.t("message.CEF_link")+"' target='_blank'>"+this.$i18n.t("message.CEF_link_text")+"</a>";
          
            var text=""
            text+="<div class='department departmentJia pad-15 '><div class='popup-content '>"+this.$i18n.t("message.CEF_text")+"</div></div>"
            text = text.replace('[link]', link);
            EventBus.$emit('showPopup', {text:text,title:this.$i18n.t("message.CEF")})
        },
        getQRInfo:function(){
            var link = "<a  class='info-link mainColor ' href='"+this.$i18n.t("message.QR_link")+"' target='_blank'>"+this.$i18n.t("message.QR_link_text")+"</a>";
          
            var text=""
            text+="<div class='department departmentJia pad-15 '><div class='popup-content '>"+this.$i18n.t("message.QR_text")+"</div></div>"
            text = text.replace('[link]', link);
            EventBus.$emit('showPopup', {text:text,title:this.$i18n.t("message.QR Courses")})
        },
        getMOOCInfo:function(){
            var text=""
            text+="<div class='department departmentJia pad-15 '><div class='popup-content '>"+this.$i18n.t("message.MOOC_text")+"</div></div>"
            EventBus.$emit('showPopup', {text:text,title:this.$i18n.t("message.MOOC Courses")})
        },
        titleCase(str) {
            var newStr = str.slice(0,1).toUpperCase() +str.slice(1).toLowerCase();
            return newStr;
		},
		getCourseOccupationList: function(key) {
			if (!key || key == -1) return;
			var that = this;
			let obj = {
				courseKey: decodeURIComponent(key),
				startRow: 0,
				maxRows: 4,
			}
			this.api.getAllCourseOccupationList(obj, function(data) {
				that.courseOccupationList = data.result;
			})
		},
		viewAllOccupationEvent: function() {
			this.$store.state.formData.courseKey = this.course.key;
			this.$router.push({
				path: "/RelatedOccupationsT",
				query: { lang: this.$store.state.language },
			})
        },
        toKnowMore() {          
            var text=""
            text+="<div class='department departmentJia pad-15 '><div class='popup-content '>"
            + "<div><a  class='info-link mainColor ' href='"+this.$i18n.t("message.cef course_link")+"' target='_blank'>"+this.$i18n.t("message.CEF")+"</a></div>"
            + "<div><a  class='info-link mainColor ' href='"+this.$i18n.t("message.cef course providers_link")+"' target='_blank'>"+this.$i18n.t("message.CEF course providers")+"</a></div>"
            +"</div></div>"
            EventBus.$emit('showPopup', {text:text, title:""})
        },
        goCourseDetail(course) {
            let key = encodeURIComponent(course.key);
            this.course.cefList = [];
            this.$router.push({path:"/courseDetailCef/" + course.dataSource + "/" + key, query:{lang:this.$store.state.language,name:this.$store.getters.replaceEvent(this.$store.getters.getObject(course.langMap).title)}});
            window.scrollTo(0,0)
        },
        viewAllCourse() {
            this.$store.state.formData.cefCourseList = this.course.cefList;
            this.$store.state.formData.cefCourseKey = this.$route.params.key;
            this.$router.push({
                path: "/ReratedCoursesC"
            })
            window.scrollTo(0,0)
        }
    }, 
    // beforeRouteLeave(to, from, next){ // 列表页面跳转到 详情页时，设置需要缓存
    //     if(to.name=='onlineMagazine'){
    //         from.meta.isUseCache = false;
    //     }
    //     next()
    // },
    activated(){
        this.$store.state.mate.width = 209;
        this.$store.state.mate.height = 209;
    },
    mounted() {
        this.$store.state.mate.width = 209;
        this.$store.state.mate.height = 209;
        window.scrollTo(0, 0);
        this.init();
        this.learnMore=function(url){
            url = url.match(/^http[s]?:\/\//) ? url : 'http://' + url;
            window.open(url)
        }
    }
}
</script>